import { Card } from "src/components/UI/Card";
import TitleTooltip from "src/components/UI/TitleTooltip";
import { KeywordAssistPageDetail } from "../../types/keyword-assist.type";

interface Props {
  meta: KeywordAssistPageDetail;
}
export default function KATextAnalysisCard({ meta }: Props) {
  return (
    <Card className="flex flex-col justify-between h-full">
      <div className="px-6">
        <div className="flex items-center gap-2 mb-4">
          <TitleTooltip>
            <TitleTooltip.Text title="Text Analysis" className="!text-[#475467] !font-medium !text-base">
              <TitleTooltip.Tooltip tooltip={
                <p className="text-primary text-sm font-medium">
                  Overview of content volume and header structure statistics.
                </p>
              } />
            </TitleTooltip.Text>
          </TitleTooltip>
        </div>

        {/* Big Number Words */}
        <div className="mb-4">
          <span className="text-sm font-semibold text-[#475467]">Words</span>
          <h2 className="text-4xl text-primary font-bold tracking-tight mt-1">
            {meta.text_analysis.words.toLocaleString()}
          </h2>
        </div>

        {/* Divider and Stats List */}
        <div className="flex flex-col">
          <div className="flex justify-between items-center py-2 border-b border-[#F2F4F7]">
            <span className="text-sm text-[#475467] font-medium">Duplicate H1</span>
            <span className={`px-2.5 py-0.5 rounded-lg text-xs font-semibold ${meta.text_analysis.duplicate_h1
                ? 'text-[#B42318] bg-[#FEF3F2]'
                : 'text-[#344054] bg-[#F2F4F7]'
              }`}>
              {meta.text_analysis.duplicate_h1 ? 'True' : 'False'}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-[#F2F4F7]">
            <span className="text-sm text-[#475467] font-medium">H1 Count</span>
            <span className="text-sm font-bold text-[#1D2939]">{meta.text_analysis.h1_count}</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-[#F2F4F7]">
            <span className="text-sm text-[#475467] font-medium">H2 Count</span>
            <span className="text-sm font-bold text-[#1D2939]">{meta.text_analysis.h2_count}</span>
          </div>
          <div className="flex justify-between items-center py-2">
            <span className="text-sm text-[#475467] font-medium">H3 Count</span>
            <span className="text-sm font-bold text-[#1D2939]">{meta.text_analysis.h3_count}</span>
          </div>
        </div>
      </div>
    </Card>
  );
}
